var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889",
    transform: "translate(15822 -8566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2980",
    "data-name": "Rectangle 2980",
    width: 16,
    height: 16,
    transform: "translate(-15822 8566)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "cancel",
    d: "M7,0a7,7,0,1,0,7,7A6.98,6.98,0,0,0,7,0ZM8.018,7.127,10.4,9.514a.308.308,0,0,1,0,.445l-.445.445a.344.344,0,0,1-.223.1.289.289,0,0,1-.223-.1L7.127,8.018a.154.154,0,0,0-.223,0L4.518,10.4a.344.344,0,0,1-.223.1.289.289,0,0,1-.223-.1l-.445-.445a.308.308,0,0,1,0-.445L6.014,7.127a.154.154,0,0,0,0-.223L3.627,4.518a.308.308,0,0,1,0-.445l.445-.445a.308.308,0,0,1,.445,0L6.9,6.014a.154.154,0,0,0,.223,0L9.514,3.627a.344.344,0,0,1,.223-.1.289.289,0,0,1,.223.1l.445.445a.308.308,0,0,1,0,.445L8.018,6.9C7.955,6.936,7.955,7.064,8.018,7.127Z",
    transform: "translate(-15821 8567)",
    fill: "#e54a49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/incorrect.5a6340e090ab733868fabcd18ae46559.svg";
export { ForwardRef as ReactComponent };